import { styled } from '@mui/material';
import { ActionButton } from 'src/components/ActionButton/ActionButton';

export const CustomActionButton = styled(ActionButton)(({ theme }) => ({
  width: '100%',
  height: theme.spacing(3),
  '& .MuiButton-root': {
    width: '100%',
    height: theme.spacing(4),
    minWidth: 'unset',
    '&:hover': {
      boxShadow: 'none',
    },
  },
}));

export const CustomButtonsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(0.5),
  alignItems: 'center',
  width: '100%',
  justifyContent: 'space-between',
  padding: theme.spacing(1, 0),
  paddingBottom: theme.spacing(2.5),
  borderBottom: '1px solid',
  borderColor: theme.palette.divider,
  position: 'relative',
}));
